export default (data) => {
  if (data) {
    let index = data.indexOf('?');
    if (index > -1) {
      return data.slice(0, index);
    }
  }
  return data;
}